// extracted by mini-css-extract-plugin
module.exports = {"row":"_3cfrNbMJiH4Q8yg-w8Unge","alignItemsCenter":"NhgUt1VZGFCit1zvYcCv8","flex1":"UVQQ4k1HU6awgKZiGk23v"};